import { Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../../../../atomic/atoms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { OrderQuery } from '../../../../../../../services/query';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { UOSSU_OTP } from '../userOrderShipmentStatusUpdate.classes';

function OtpOrIdentityVerification({
    selectedShipment,
    otpVerificationCode,
    setOtpVerificationCode,
    isVerified,
    setIsVerified,
    handleCloseModal,
    selectedOption,
    setSelectedOption,
}: any) {
    const { t } = useTranslation();
    const { data }: any = useSelector((state: any) => state.orderDetails);
    const [showOtpOption, setShowOtpOption] = useState<boolean>(true);
    const [disabledVerification, setDisabledVerification] = useState(false);

    useEffect(() => {
        const getCountryId = () => {
            return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryId || 0;
        };

        const countryId = getCountryId();

        // Global rule kontrolü - tüm ülkeler için çalışır
        // Rule'dan gelen outcome true ise OTP adımını gizle
        OrderQuery.CheckOtpAvailability({ countryId })
            .then((res: any) => {
                if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
                    const outcome = res?.data[0]?.outcome;
                    if (outcome === true) {
                        setShowOtpOption(false);
                        setSelectedOption('Identity');
                    } else {
                        setShowOtpOption(true);
                    }
                } else {
                    setShowOtpOption(true);
                }
            })
            .catch(() => {
                setShowOtpOption(true);
            });
    }, []);

    const handleResendOtp = () => {
        OrderQuery.ResendOtp({
            shippingListId: selectedShipment.shippingListId,
            customerId: data.customerId,
        })
            .then((res: any) => {
                if (res.data)
                    Swal.fire(t('orderDetail.otpCodeSent'), t('orderDetail.otpCodeSentSuccessfully'), 'success');
            })
            .catch(() => {
                Swal.fire(t('orderDetail.error'), t('general.anErrorOccured'), 'error');
            });
    };

    const handleVerification = () => {
        setDisabledVerification(true);
        if (!otpVerificationCode) {
            handleCloseModal();
            return Swal.fire(t('orderDetail.enterOtpCode'), t('orderDetail.pleaseEnterValidOtp'), 'error');
        }
        setIsVerified(false);
        OrderQuery.VerifyOtp({
            shippingListId: selectedShipment.shippingListId,
            verificationCode: otpVerificationCode,
        })
            .then((res: any) => {
                if (res.data) {
                    setIsVerified(true);
                } else {
                    setDisabledVerification(false);
                    Swal.fire(t('orderDetail.error'), t('orderDetail.verificationFailed'), 'error');
                }
            })
            .catch(() => {
                setDisabledVerification(false);
                Swal.fire(t('orderDetail.error'), t('orderDetail.verificationFailed'), 'error');
            });
    };
    return (
        <FormControl
            className={UOSSU_OTP.verificationFormControl}
            disabled={disabledVerification}
            component="fieldset"
            style={{ border: '2px solid #ccc', padding: '1rem', marginTop: '1rem' }}
        >
            <FormLabel className={UOSSU_OTP.verificationLegend} style={{ marginTop: '1rem' }} component="legend">
                {t('orderDetail.selectVerificationMethod')}
            </FormLabel>
            <RadioGroup
                className={UOSSU_OTP.verificationRadioGroup}
                row
                aria-label="verification"
                name="verification"
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
            >
                {showOtpOption && (
                    <FormControlLabel
                        className={UOSSU_OTP.radioOtp}
                        value="OTP"
                        control={<Radio />}
                        label={t('orderDetail.otp')}
                    />
                )}
                <FormControlLabel
                    className={UOSSU_OTP.radioIdentity}
                    value="Identity"
                    control={<Radio />}
                    label={t('orderDetail.identity')}
                />
            </RadioGroup>
            {selectedOption === 'OTP' && showOtpOption && (
                <div className={UOSSU_OTP.otpSection} style={{ display: 'flex', flexDirection: 'column' }}>
                    <SCUIButton
                        className={UOSSU_OTP.inputButtonResendOtp}
                        disabled={disabledVerification}
                        style={{ minWidth: '40px', height: 'auto', marginBottom: '1rem' }}
                        onClick={handleResendOtp}
                        type={'primary'}
                        sizeType={'fixed'}
                        size={'s'}
                        text={t('orderDetail.resendVerification')}
                    ></SCUIButton>

                    <div
                        className={UOSSU_OTP.otpInputRow}
                        style={{
                            gap: '1rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '1rem',
                        }}
                    >
                        <TextField
                            className={UOSSU_OTP.inputTextOtpCode}
                            label={t('orderDetail.enterOtp')}
                            variant="outlined"
                            value={otpVerificationCode}
                            onChange={(e) => setOtpVerificationCode(e.target.value)}
                            disabled={disabledVerification}
                            type="number"
                        />
                        <SCUIButton
                            className={UOSSU_OTP.inputButtonVerifyOtp}
                            disabled={disabledVerification}
                            style={{ width: '30px', height: 'auto' }}
                            onClick={() => handleVerification()}
                            type={'primary'}
                            sizeType={'fixed'}
                            size={'l'}
                            text={t('orderDetail.verify')}
                        ></SCUIButton>
                    </div>
                </div>
            )}
            {selectedOption === 'Identity' && (
                <div
                    className={UOSSU_OTP.identitySection}
                    style={{
                        gap: '1rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <SCUIButton
                        className={UOSSU_OTP.inputButtonIdentityVerify}
                        disabled={disabledVerification}
                        style={{ marginTop: '1rem' }}
                        onClick={() => {
                            setIsVerified(true);
                            setDisabledVerification(true);
                        }}
                        type={'primary'}
                        sizeType={'fixed'}
                        size={'l'}
                        text={t('orderDetail.identityVerification')}
                    ></SCUIButton>
                </div>
            )}
            <Divider className={UOSSU_OTP.statusDivider} style={{ marginTop: '1rem' }} />
            <div
                className={UOSSU_OTP.statusRow}
                style={{
                    gap: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '1rem',
                }}
            >
                <p>{t('orderDetail.verificationStatus')}</p>
                {isVerified ? (
                    <CheckCircleIcon className={UOSSU_OTP.statusIconVerified} fontSize="large" color="success" />
                ) : (
                    <CancelIcon className={UOSSU_OTP.statusIconFailed} fontSize="large" color="error" />
                )}
            </div>
        </FormControl>
    );
}

export default OtpOrIdentityVerification;
